import React, { Component } from 'react';
import { Paper } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import i18n from '../../i18n';
import SimpleDialogFragment from './SimpleDialogFragment';
import '../../assets/stylesheets/Setting.css';

class GenericWarningModal extends Component {
  render() {
    const { showWarningModal, hideWarningModal, message } = this.props;

    return (
      <Modal open={showWarningModal} onClose={hideWarningModal}>
        <Paper className="deleteModal">
          <SimpleDialogFragment
            title={message}
            buttonLabel={i18n.t('close')}
            onClick={hideWarningModal}
          />
        </Paper>
      </Modal>
    );
  }
}

GenericWarningModal.propTypes = {
  showWarningModal: PropTypes.bool.isRequired,
  hideWarningModal: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

export default GenericWarningModal;
